export interface OrderStatus {
  statusCode: string;
  statusDesc: string;
  statusId: number;
  inEdit?: string;
}
